import React, { useEffect } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";

const Confirmation = ({ 
  onOpen, 
  onClose, 
  onConfirm, 
  message = "are you want to create a new version !!", 
  noText = "No! i am not ", 
  yesText = "Yes! i am sure" 
}) => {
  useEffect(() => {
    // console.log("Open");
  }, []);
  return (
    <div>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div className="mt-10">
          <p className="text-lg text-center font-light px-4">
            {message}
          </p>

          <div className="flex justify-center gap-4 py-6">
            <CustomButton
              buttonType="primary"
              variant="cancel"
              buttonText={noText}
              className="text-sm px-6 py-2 rounded-lg"
              onClick={onClose}
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText={yesText}
              className=" text-sm px-6 py-2 rounded-lg"
              onClick={() => {
                onConfirm();
              }}
            />
          </div>
        </div>
      </DailogBox>
    </div>
  );
};

export default Confirmation;
